import { render, staticRenderFns } from "./UserDeleted.vue?vue&type=template&id=0984f690&scoped=true"
import script from "./UserDeleted.vue?vue&type=script&lang=js"
export * from "./UserDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984f690",
  null
  
)

export default component.exports